import { Link } from "react-router-dom";

const ProjectCard = ({ imageUrl, popupImageUrl, title, description, detailsUrl }) => {
    return (
        <div className="col-xl-4 col-lg-4">
            <div className="project-one__single wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                <div className="project-one__single-img">
                    <div className="inner">
                        <div style={{backgroundImage: `url(${imageUrl})`}} alt={title} className="h-[493px] w-[370px] bg-cover bg-center" />
                        <div className="project-one__link">
                            <a className="img-popup" href={popupImageUrl}>
                                <span className="icon-plus-sign"/>
                            </a>
                        </div>
                    </div>
                    <div className="content-box">
                        <h2><Link to={detailsUrl}>{title}</Link></h2>
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectCard;
